<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M11.6667 7.94667V5.83333C11.6667 4.94928 12.0179 4.10143 12.643 3.47631C13.2681 2.85119 14.1159 2.5 15 2.5H16.25C16.3605 2.5 16.4665 2.5439 16.5446 2.62204C16.6228 2.70018 16.6667 2.80616 16.6667 2.91667V4.16667C16.6667 5.05072 16.3155 5.89857 15.6904 6.52369C15.0652 7.14881 14.2174 7.5 13.3333 7.5C12.4493 7.5 11.6014 7.85119 10.9763 8.47631C10.3512 9.10143 10 9.94928 10 10.8333C10 12.5 10.8333 13.3333 10.8333 15C10.8333 15.9015 10.5409 16.7788 10 17.5"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.33313 7.50033C3.95217 7.03605 4.68827 6.75332 5.45894 6.68383C6.22961 6.61434 7.00441 6.76083 7.69652 7.10688C8.38863 7.45293 8.9707 7.98488 9.37751 8.64311C9.78432 9.30135 9.9998 10.0599 9.9998 10.8337C9.38076 11.2979 8.64466 11.5807 7.87399 11.6502C7.10331 11.7196 6.32851 11.5732 5.63641 11.2271C4.9443 10.8811 4.36223 10.3491 3.95542 9.69087C3.54861 9.03264 3.33313 8.27413 3.33313 7.50033Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M4.16687 17.5H15.8335"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSeedling',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
